//トップページ　キービジュアルスライダー
import Swiper from 'swiper/bundle';
import yycountdown from "../lib/jquery.yycountdown.min.js";
export function idxFunc() {
  let flag = false;
  $('.accordionBtn').on('click', function () {
    $(this).prev().find('dd').stop().slideToggle('500');
    if (flag) {
      $(this).text('詳しく読む');
      flag = false;
    } else {
      $(this).text('閉じる');
      flag = true;
    }
  });

  const swiperSlides = document.getElementsByClassName('swiper-slide');
  const breakPoint = 768;
  let mySwiper;
  let mySwiperBool;
  let responsibleCheck;
  window.addEventListener('resize', () => {
    if (breakPoint < window.innerWidth && mySwiperBool) {
      mySwiper.destroy(false, true);
      mySwiperBool = false;
    } else if (breakPoint >= window.innerWidth && !(mySwiperBool)) {
      createSwiper();
      mySwiperBool = true;
    }
  }, false);

  const createSwiper = () => {
    mySwiper = new Swiper('.swiper', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next'
      },
    });
  }

  responsibleCheck = $('#responsibleCheck').width();
  //初回読み込み時
  if (responsibleCheck == 1) {
    mySwiperBool = false;
  } else {
    createSwiper();
    mySwiperBool = true;
  }


  //タイムセール機能実装
  if (!localStorage.getItem('firstTime')) {
    //初回アクセスの場合
    localStorage.setItem('firstTime', 'true');
    //現在の時刻を取得
    let getStartTime, endTime;
    getStartTime = new Date();
    //3日後の日時を取得
    endTime = new Date(getStartTime.setDate(getStartTime.getDate() + 3));
    localStorage.setItem('endTime', endTime);
    $('.jsTimer').yycountdown({
      endDateTime: endTime, //カウントダウン終了日時
      unit: {
        d: '日',
        h: '時間',
        m: '分',
        s: '秒'
      },
      complete: function (_this) {
        _this.empty().text('終了しました');
      }
    });
  } else {
    //初回以降の場合
    let getStartTime, endTime;
    getStartTime = new Date();
    endTime = localStorage.getItem('endTime');
    $('.jsTimer').yycountdown({
      startDateTime: getStartTime,
      endDateTime: endTime,
      unit: {
        d: '日',
        h: '時間',
        m: '分',
        s: '秒'
      },
      complete: function (_this) {
        _this.empty().text('終了しました');
      }
    });
  }

  $('.Sandbox').on('click', function () {
    localStorage.clear();
    location.reload();
  });

  $('#frame1,.movieOn1').on('click', function () {
    $('.videoArea').addClass('open');
    $('.youtube').html('<iframe width="560" height="315" src="https://www.youtube.com/embed/NzDiLEjc8zQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="movie open" id="popup-YouTube-player"></iframe>');
  });
  $('#frame2,.movieOn2').on('click', function () {
    $('.videoArea').addClass('open');
    $('.youtube').html('<iframe width="560" height="315" src="https://www.youtube.com/embed/aiqbpwQIXAk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="movie open"></iframe>');
  });
  $('.overlay,.closeBtn').on('click', function () {
    $('.videoArea').removeClass('open');
    $('.no1,.no2').removeClass('open');
    $('.youtube').html('');
  });

}